import React from 'react'
import '../../../design/App.css'
import { Col, Layout, Row, Space } from 'antd'
import { observer } from 'mobx-react-lite'
import PropTypes from 'prop-types'
import { siderStyle } from '../../../design/app-style-config'
import { CloseCircleOutlined } from '@ant-design/icons'
import { isMobile } from 'react-device-detect'
import NavBarSide from './NavBarSide'
import { translate } from '../../../cls/TranslationContext'
const { Sider } = Layout

const Sidebar = observer(({ collapsed, setCollapsed }) => {
	return (
		<Sider
			id="app-sidebar"
			trigger={null}
			collapsible
			collapsed={collapsed}
			onCollapse={(value) => setCollapsed(value)}
			width={isMobile ? '100%' : 240}
			height="calc(100vh - 40px)"
			style={siderStyle}
			hidden={isMobile && collapsed}
		>
			<Row
				justify={!isMobile && collapsed ? 'center' : 'space-between'}
				style={{
					padding: collapsed
						? '16px 10px 15px 10px'
						: '16px 10px 15px 14px'
				}}
			>
				<Col justify="center">
					{collapsed ? (
						<a href="/">
							<img
								src="/webackit-logo-color.svg"
								alt="webackit.com logo"
								style={{ height: '30px' }}
							/>
						</a>
					) : (
						<Space style={{ width: '100%' }}>
							<a href="/">
								<img
									src="/webackit-logo-color.svg"
									alt="webackit.com logo"
									style={{ height: '30px' }}
								/>
							</a>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginTop: '-5px',
									marginLeft: '-2px',
									lineHeight: 1
								}}
							>
								<span style={{ fontSize: 14, lineHeight: 1 }}>
									On subscription
								</span>

								<span style={{ fontSize: 8, lineHeight: 1 }}>
									{translate('single.powered-by')}{' '}
									webackit.com
								</span>
							</div>
						</Space>
					)}
				</Col>

				{/* Show the close menu icon only for mobile devices */}
				{isMobile && !collapsed && (
					<Col>
						<CloseCircleOutlined
							style={{
								fontSize: '25px',
								cursor: 'pointer'
							}}
							onClick={() => setCollapsed(true)}
						/>
					</Col>
				)}
			</Row>
			<NavBarSide collapsed={collapsed} setCollapsed={setCollapsed} />
		</Sider>
	)
})

Sidebar.propTypes = {
	collapsed: PropTypes.bool,
	setCollapsed: PropTypes.func
}

export default Sidebar
